import { useMemo } from 'react';

import { useInitLikedProducts } from '@widgets/like-product';
import { queryOptions, useCatalogProductIdParams, useDocumentVisibleOnce } from '@domains/pdp-common';

import { MIN_DISPLAY_COUNT } from '../constants/constant';
import { usePdpInfiniteRecommendList } from '../query/usePdpInfiniteRecommendList';
import {
  convertPdpGoodsCardItemListToCatalogProductIdList,
  convertUxGoodsCardItemFromPdpGoodsCardItem,
} from '../utils/convert';
import { GetRecommendListType } from './types';

export const useInfiniteRecommendList = (): GetRecommendListType => {
  const { ref: targetRef, isPermanentlyOnce } = useDocumentVisibleOnce();
  const { catalog_product_id } = useCatalogProductIdParams();

  const response = usePdpInfiniteRecommendList({
    catalog_product_id,
    ...queryOptions,
    keepPreviousData: true,
    enabled: isPermanentlyOnce,
  });

  const { data } = response;

  const item_list = useMemo(
    () =>
      response.data?.pages?.flatMap((item) => item?.item_list?.map(convertUxGoodsCardItemFromPdpGoodsCardItem) ?? []) ??
      [],
    [response.data?.pages],
  );

  useInitLikedProducts({
    data: item_list,
    convert: convertPdpGoodsCardItemListToCatalogProductIdList,
  });

  return {
    targetRef,
    response,
    title: data?.pages[0]?.title?.text ?? '당신을 위한 추천 상품',
    subTitle: data?.pages[0]?.sub_title?.text,
    isAd: data?.pages[0]?.is_ad,
    itemList: item_list,
    isEmpty: response.isFetched && !response.hasNextPage && item_list.length < MIN_DISPLAY_COUNT,
    selectedDrLogMap: null,
  };
};
